module.exports = __webpack_public_path__ + "media/images/question_examples/question-example-single-image-1d0e4f81540bab1a14e24e2d520e49fa.png";